import React from 'react';
import { CheckCircle2, Circle } from 'lucide-react';
interface OptionCardProps {
  id: string;
  title: string;
  description: string;
  isSelected?: boolean;
  onClick?: () => void;
}
export function OptionCard({
  id,
  title,
  description,
  isSelected = false,
  onClick
}: OptionCardProps) {
  return <div onClick={onClick} className={`
        relative flex items-start p-5 rounded-xl border transition-all duration-200 cursor-pointer
        ${isSelected ? 'border-indigo-600 bg-indigo-50/50 shadow-sm ring-1 ring-indigo-600' : 'border-slate-200 bg-white hover:border-indigo-300 hover:shadow-sm'}
      `} role="radio" aria-checked={isSelected} tabIndex={0} onKeyDown={e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick?.();
    }
  }} data-id="element-172">
      {/* Content */}
      <div className="flex-1 pr-4" data-id="element-173">
        <h3 className="font-semibold text-slate-900 mb-1 text-base" data-id="element-174">{title}</h3>
        <p className="text-slate-500 text-sm leading-relaxed" data-id="element-175">{description}</p>
      </div>

      {/* Radio Indicator */}
      <div className="mt-0.5" data-id="element-176">
        {isSelected ? <div className="text-indigo-600" data-id="element-177">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-178">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" data-id="element-179" />
              <circle cx="12" cy="12" r="5" fill="currentColor" data-id="element-180" />
            </svg>
          </div> : <div className="text-slate-200" data-id="element-181">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-182">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" data-id="element-183" />
            </svg>
          </div>}
      </div>
    </div>;
}